module.exports = __webpack_public_path__ + "static/media/right-arrow-with-lines.0bd5ad60.svg";